import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * gets amp response for assetId
 * @param {string} assetId - assetId of the query
 * @param {boolean} evergreen - whether to query for an evergreen asset
 * @returns {Promise<Response>} the reponse object
 */
export const getAmpAssetIdResponse = function getAmpAssetIdResponse(assetId, evergreen) {
  const headers = authHeaders();
  const url = `${CCS_URL}/amp/asset?assets=${assetId}${evergreen ? '&type=evergreen' : ''}`;
  return betterFetch(url, { headers });
};

/**
 * gets amp response for workFrontId
 * @param {string} workfrontId - workfrontId of the query
 * @returns {Promise<Response>} the reponse object
 */
export const getAmpWorkFrontResponse = function getAmpWorkFrontResponse(workfrontId) {
  const headers = authHeaders();
  return betterFetch(`${CCS_URL}/amp/asset?workfrontid=${workfrontId}`, { headers });
};
